export default __webpack_public_path__ + "img/menub.c05385b1.svg";